import { HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpUrlEncodingCodec } from './http-url-encoding-codec';
import { RequestOptionsArguments } from './request-options-arguments';

export class RequestOptions {
  constructor(private requestArguments: RequestOptionsArguments) { }

  get headers(): HttpHeaders {
    return new HttpHeaders(this.requestArguments.headers || {});
  }

  get params(): HttpParams {
    return Object.entries(this.requestArguments.params || {}).reduce(
      (acc, [key, value]) => acc.set(key, value),
      new HttpParams({ encoder: new HttpUrlEncodingCodec() }),
    );
  }
}
